/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useDispatch } from "react-redux";
import { change } from "redux-form";

// import DownloadIcon from "@material-ui/icons/GetApp";

import {
  List,
  FilterButton,
  changePaginationParams,
  Filter,
  ReferenceArrayInput,
  SelectInput,
  SelectArrayInput,
  AutoCompleteArrayInput
} from "jazasoft";

// import { useMutation, useTime, useUnit } from "../../hooks";
import { useQuery, useTime, useUnit } from "../../hooks";

import CustomDatagrid from "./CustomDatagrid";
import { inputOptions } from "../../utils/helpers";
import { OState } from "../../utils/types";

const statusChoices = [
  { id: "New", name: "New" },
  { id: "In Progress", name: "In Progress" },
  { id: "Closed", name: "Closed" }
];

const filters = (productList = [], unitChoices = []) => (
  <Filter>
    {unitChoices?.length > 2 && <SelectInput source="unitId" choices={unitChoices} {...inputOptions(12)} />}
    <SelectInput label="Status" source="status" choices={statusChoices} {...inputOptions(12)} />
    <SelectInput label="Products" source="productId" choices={productList.map(p => ({ id: p.id, name: p.name }))} {...inputOptions(12)} />
    <ReferenceArrayInput
      label="Season"
      resource="seasons"
      source="seasonId"
      reference="seasons"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions(12)}>
      <SelectArrayInput />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      label="Customer"
      resource="customers"
      source="customerId"
      reference="customers"
      sort={{ field: "name", order: "asc" }}
      {...inputOptions(12)}>
      <AutoCompleteArrayInput disablePortal={true} {...inputOptions(12)} />
    </ReferenceArrayInput>
  </Filter>
);

const parse = ({ unitId, customerId, seasonId, productId, status }) => ({
  state:
    status === "In Progress"
      ? Object.values(OState)
          .filter(e => e.state !== OState.NEW.state && e.state !== OState.PART_DETAIL_PENDING.state && e.state !== OState.CLOSED.state)
          .map(e => e.state)
      : status === "In Progress"
      ? [OState.NEW.state, OState.PART_DETAIL_PENDING.state]
      : [status],
  unitId: unitId === "all" ? undefined : unitId,
  "order.customer.id": customerId,
  "order.season.id": seasonId,
  "product.id": productId
});

const OrderStatusHome = props => {
  const dispatch = useDispatch();
  const { utc_offset } = useTime();

  // const [mutate, { loading: busy }] = useMutation({ rawResponse: true });

  const { data: productList = [] } = useQuery({ url: "products", params: { size: 1000, sort: "name,asc" } });

  const { allUnitList } = useUnit();
  const unitChoices = [{ id: "all", name: "All Units" }, ...allUnitList.map(({ unitId, name }) => ({ id: unitId, name }))];

  React.useEffect(() => {
    dispatch(changePaginationParams(props.resource, 0, 25));
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(change("filter-form", "status", "In Progress"));
  }, [dispatch]);

  // const onDownload = () => {};

  return (
    <div>
      <List
        pageSize={25}
        searchKeys={["order.poRef", "order.customerPoRef", "style", "customerFlowRef"]}
        actions={({ resource }) => (
          <div>
            {/* <Button showLabel={false} label="js.action.download" disabled={busy} onClick={onDownload}>
              <DownloadIcon />
            </Button> */}
            <FilterButton showLabel={false} resource={resource} />
          </div>
        )}
        filters={filters(productList, unitChoices)}
        filterDefaultValues={{ status: "In Progress" }}
        parse={parse}
        {...props}>
        <CustomDatagrid utc_offset={utc_offset} unitList={allUnitList} />
      </List>
    </div>
  );
};

export default OrderStatusHome;
